import React, { useState, useEffect } from "react";
import "./PageStyles.css";

const HomePage = ({ setActiveTab }) => {
  const [latestContent, setLatestContent] = useState([]);
  const [loading, setLoading] = useState(true);

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [articlesRes, tutorialsRes, gamesRes] = await Promise.all([
          fetch(`${apiUrl}/articles`),
          fetch(`${apiUrl}/tutorials`),
          fetch(`${apiUrl}/games`),
        ]);

        const articlesData = await articlesRes.json();
        const tutorialsData = await tutorialsRes.json();
        const gamesData = await gamesRes.json();

        const articles = Array.isArray(articlesData) ? articlesData : (JSON.parse(articlesData.body || "[]"));
        const tutorials = Array.isArray(tutorialsData) ? tutorialsData : (JSON.parse(tutorialsData.body || "[]"));
        const games = Array.isArray(gamesData) ? gamesData : (JSON.parse(gamesData.body || "[]"));

        // Combine and sort by date
        const allContent = [
          ...articles.map((a) => ({ ...a, type: "Article", tab: "articles" })),
          ...tutorials.map((t) => ({ ...t, type: "Tutorial", tab: "tutorials" })),
          ...games.map((g) => ({ ...g, type: "Game", tab: "games", published_at: g.date, summary: g.description })),
        ].sort((a, b) => new Date(b.published_at) - new Date(a.published_at));

        setLatestContent(allContent.slice(0, 3)); // Top 3
      } catch (error) {
        console.error("Error fetching latest content:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [apiUrl]);

  return (
    <div className="page-container">
      {/* 1. Hero Welcome Section */}
      <section className="hero-welcome-section">
        <img
          src="/High-Resolution-Color-Logo-on-Transparent-Background.png"
          alt="Szafranski Computing Logo"
          className="hero-logo"
        />
        <h2>Welcome to Szafranski Computing</h2>
        <p>
          Your hub for cutting-edge technology insights, coding tutorials, and
          software development expertise. Whether you're here to learn, explore,
          or collaborate, we're glad to have you.
        </p>

        <div className="hero-cta-buttons">
          <a
            href="#!"
            className="cta-button primary"
            onClick={() => setActiveTab("articles")}
          >
            Read Articles
          </a>
          <a
            href="#!"
            className="cta-button secondary"
            onClick={() => setActiveTab("tutorials")}
          >
            Start Learning
          </a>
          <a
            href="#!"
            className="cta-button primary"
            style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
            onClick={() => setActiveTab("games")}
          >
            Play Games
          </a>
        </div>
      </section>

      {/* 2. Featured Posts Section */}
      <section className="featured-posts-section">
        <h2>Latest Updates</h2>
        {loading ? (
          <p>Loading latest content...</p>
        ) : (
          <div className="content-grid">
            {latestContent.length > 0 ? (
              latestContent.map((item, index) => (
                <div key={index} className="content-card">
                  <h3>{item.title}</h3>
                  <p>{item.summary}</p>
                  <a
                    href="#!"
                    className="card-link"
                    onClick={() => setActiveTab(item.tab)}
                  >
                    {item.type === "Game" ? "Play" : "Read"} {item.type} &rarr;
                  </a>
                  <span>
                    Published on: {new Date(item.published_at).toLocaleDateString()}
                  </span>
                </div>
              ))
            ) : (
              <p>No updates yet. Check back soon!</p>
            )}
          </div>
        )}
      </section>

      {/* 3. Services / CTA Section */}
      {/* <section className="services-cta-section">
        <h2>Need Custom Software Solutions?</h2>
        <p>
          I specialize in building high-performance web applications, cloud
          infrastructure, and scalable backend systems. Let's turn your ideas
          into reality.
        </p>
        <a
          href="#"
          className="cta-button primary"
          onClick={() => setActiveTab("contact")}
        >
          Get in Touch
        </a>
      </section> */}
    </div>
  );
};

export default HomePage;
